<template>
  <div class="alignment">
    <!-- <v-btn class="right" color="blue" > Modifica </v-btn>
    <v-btn class="right" color="red"  > Cancella </v-btn>-->

    <template>
      <v-layout row wrap>
        <v-flex xs6 class="text-xs-left">
          <h3 class="styleHeader">
            {{ $t("pages.UserOperation.Index.MappaturaUtenteOperazione") }}
          </h3>
        </v-flex>
        <v-flex>
          <v-btn
            class="right white--text styleHeader styleAlignamentAddButton"
            :to="$i18nRoute({ name: 'UsersOperationsCreate' })"
            color="#279947"
          >
            <v-icon left>add</v-icon>
            {{ $t("pages.UserOperation.Index.Aggiungi") }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="[
          {
            text: this.currentLanguage.t('pages.UserOperation.Index.Utente'),
            value: 'UserId'
          },
          {
            text: this.currentLanguage.t(
              'pages.UserOperation.Index.DescEstrazione'
            ),
            value: 'OperationId'
          },
          { text: '' },
          { text: '' }
        ]"
        :items="usersOperations"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>{{ props.item.Name }} {{ props.item.Surname }}</td>
          <td>{{ props.item.Description }}</td>
          <td>
            <v-btn flat icon class="right" @click="editItem(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn flat icon class="right" @click="confirm(props.item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-alert
        class="centerButton"
        :value="conferma"
        transition="scale-transition"
      >
        {{ $t("pages.UserOperation.Index.ConfermaElimina") }}
        <v-btn @click="deleteItem()">{{
          $t("pages.UserOperation.Index.Conferma")
        }}</v-btn>
        <v-btn @click="conferma = !conferma">{{
          $t("pages.UserOperation.Index.Annulla")
        }}</v-btn>
      </v-alert>
    </template>
  </div>
</template>

<script>
import usersOperationsApi from "../../apiSmartLogistics/usersoperationsApi.js";
import router from "@/router/index.js";
import { Trans } from "@/plugins/Translation";
export default {
  data() {
    return {
      conferma: false,
      sUserOperation: {},
      usersOperations: [],
      refreshMenu: ""
    };
  },
  computed: {
    currentLanguage() {
      return Trans.i18n;
    }
  },
  methods: {
    confirm(selectedUserOperation) {
      this.sUserOperation = selectedUserOperation;
      this.conferma = true;
    },

    deleteItem() {
      usersOperationsApi
        .DeleteViewUsersOperations(this.sUserOperation.Id)
        .then(() => {
          this.conferma = false;
          this.$emit("refreshMenu", this.refreshMenu);
          this.getUserOperations();
        });
    },

    editItem(item) {
      router.push({ name: "UsersOperationsCreate", params: { Id: item.Id } });
    },

    getUserOperations() {
      usersOperationsApi.GetViewUsersOperations().then(response => {
        this.usersOperations = response.data;
      });
    }
  },

  created() {
    this.getUserOperations();
  }
};
</script>
